/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  root: 'root_b7cd2856',
  dropdown: 'dropdown_b7cd2856',
};

export = styles;

loadStyles([{"rawString":".root_b7cd2856{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline}.root_b7cd2856 .dropdown_b7cd2856{margin-bottom:0;margin-left:5px}"}]);
/* tslint:enable */